// Cấu hình phân quyền theo menu: Nhóm menu → Chức năng → Hành động.
// Mỗi (path + action) tương ứng 1 bản ghi Permission ở backend.
// Thêm menu/chức năng mới: khai báo ở đây rồi bấm "Import routes" ở trang Vai trò.

export type PermissionAction =
  | "VIEW"
  | "CREATE"
  | "UPDATE"
  | "DELETE"
  | "EXPORT"
  | "SEND_EMAIL"
  | "BLOCK"
  | "RESET_PASSWORD"
  | "ONLY_MINE"
  | "APPROVE"
  | "UPDATE_DEBT"
  | "UNLOCK"
  | "VIEW_SENSITIVE"
  | "IMPORT"
  | "LOCK";

// Thứ tự cột hiển thị trong bảng phân quyền
export const PERMISSION_ACTIONS: { key: PermissionAction; title: string }[] = [
  { key: "VIEW", title: "Xem" },
  { key: "CREATE", title: "Thêm" },
  { key: "UPDATE", title: "Sửa" },
  { key: "UPDATE_DEBT", title: "Cập nhật công nợ" },
  { key: "APPROVE", title: "Duyệt báo giá" },
  { key: "LOCK", title: "Chốt tháng" },
  { key: "UNLOCK", title: "Mở khoá" },
  { key: "DELETE", title: "Xoá" },
  { key: "BLOCK", title: "Khoá/Mở" },
  { key: "RESET_PASSWORD", title: "Reset mật khẩu" },
  { key: "ONLY_MINE", title: "Chỉ mình tôi" },
  { key: "VIEW_SENSITIVE", title: "Xem thông tin nhạy cảm" },
  { key: "IMPORT", title: "Import Excel" },
  { key: "EXPORT", title: "Xuất Excel" },
  { key: "SEND_EMAIL", title: "Gửi Email" },
];

export interface PermissionFeature {
  path: string; // trùng path của route (dùng cho quyền Xem / vào menu)
  title: string;
  actions: PermissionAction[];
}

// Thứ tự các nhóm hiển thị trong bảng phân quyền của vai trò (theo thanh menu)
export const PERMISSION_SECTIONS = ["Bán hàng", "Công việc", "SALE", "HH KT", "Tài chính", "Nhân sự", "Quản trị"];

export interface PermissionGroup {
  key: string;
  section: string; // nhóm hiển thị trong bảng phân quyền, một giá trị của PERMISSION_SECTIONS
  menuName: string;
  title: string;
  features: PermissionFeature[];
}

export const permissionMenu: PermissionGroup[] = [
  {
    key: "lead",
    section: "Bán hàng",
    title: "Quản lý lead",
    menuName: "lead",
    features: [
      {
        path: "/lead",
        title: "Danh sách lead (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE"],
      },
    ],
  },
  {
    key: "customer",
    section: "Bán hàng",
    title: "Quản lý khách hàng",
    menuName: "customer",
    features: [
      {
        path: "/customer",
        title: "Danh sách khách hàng (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE", "IMPORT", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "opportunity",
    section: "Bán hàng",
    title: "Quản lý cơ hội",
    menuName: "opportunity",
    features: [
      {
        path: "/opportunity",
        title: "Danh sách cơ hội (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE", "APPROVE", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "quote",
    section: "Bán hàng",
    title: "Quản lý báo giá",
    menuName: "quote",
    features: [
      {
        path: "/quote",
        title: "Danh sách báo giá (Menu)",
        actions: ["VIEW", "UPDATE", "APPROVE", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "order",
    section: "Bán hàng",
    title: "Quản lý đơn hàng",
    menuName: "order",
    features: [
      {
        path: "/order",
        title: "Danh sách đơn hàng (Menu)",
        actions: ["VIEW", "UPDATE", "DELETE", "UPDATE_DEBT", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "feedback",
    section: "Công việc",
    title: "Quản lý phản hồi",
    menuName: "feedback",
    features: [
      {
        path: "/feedback",
        title: "Danh sách phản hồi (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "todo",
    section: "Công việc",
    title: "Quản lý việc cần làm",
    menuName: "todo",
    features: [
      {
        path: "/todo",
        title: "Danh sách việc cần làm (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "work-schedule",
    section: "Công việc",
    title: "Quản lý lịch công tác",
    menuName: "work-schedule",
    features: [
      {
        path: "/work-schedule",
        title: "Lịch công tác (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "staff",
    section: "Quản trị",
    title: "Quản lý nhân viên",
    menuName: "staff",
    features: [
      {
        path: "/staff",
        title: "Danh sách nhân viên (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE", "BLOCK", "RESET_PASSWORD"],
      },
    ],
  },
  {
    key: "role",
    section: "Quản trị",
    title: "Quản lý vai trò",
    menuName: "role",
    features: [
      {
        path: "/role",
        title: "Danh sách vai trò (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE"],
      },
    ],
  },
  {
    key: "commission",
    section: "SALE",
    title: "Hoa hồng SALE",
    menuName: "commission",
    features: [
      {
        path: "/commission",
        title: "Hoa hồng SALE (Menu)",
        actions: ["VIEW", "CREATE", "UNLOCK", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "sale-stats",
    section: "SALE",
    title: "Thống kê SALE",
    menuName: "sale-stats",
    features: [
      {
        path: "/sale-stats",
        title: "Thống kê SALE (Menu)",
        actions: ["VIEW", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "revenue",
    section: "Tài chính",
    title: "Doanh thu",
    menuName: "revenue",
    features: [
      {
        path: "/revenue",
        title: "Doanh thu (Menu)",
        actions: ["VIEW"],
      },
    ],
  },
  {
    key: "commission-technical",
    section: "HH KT",
    title: "Hoa hồng kỹ thuật",
    menuName: "commission-technical",
    features: [
      {
        path: "/commission-technical",
        title: "Hoa hồng kỹ thuật (Menu)",
        actions: ["VIEW", "UPDATE"],
      },
    ],
  },
  {
    key: "commission-chuong",
    section: "HH KT",
    title: "HH Chương",
    menuName: "commission-chuong",
    features: [
      {
        path: "/commission-chuong",
        title: "HH Chương (Menu)",
        actions: ["VIEW"],
      },
    ],
  },
  {
    key: "commission-dung",
    section: "HH KT",
    title: "HH Dung",
    menuName: "commission-dung",
    features: [
      {
        path: "/commission-dung",
        title: "HH Dung (Menu)",
        actions: ["VIEW"],
      },
    ],
  },
  {
    key: "expense",
    section: "Tài chính",
    title: "Chi phí",
    menuName: "expense",
    features: [
      {
        path: "/expense",
        title: "Chi phí (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE"],
      },
    ],
  },
  {
    key: "profit",
    section: "Tài chính",
    title: "Lợi nhuận",
    menuName: "profit",
    features: [
      {
        path: "/profit",
        title: "Lợi nhuận (Menu)",
        actions: ["VIEW"],
      },
    ],
  },
  {
    key: "debt",
    section: "Tài chính",
    title: "Công nợ",
    menuName: "debt",
    features: [
      {
        path: "/debt",
        title: "Công nợ (Menu)",
        actions: ["VIEW", "UPDATE", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "employee",
    section: "Nhân sự",
    title: "Nhân sự",
    menuName: "employee",
    features: [
      {
        path: "/employee",
        title: "Danh sách nhân sự (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE", "VIEW_SENSITIVE"],
      },
    ],
  },
  {
    key: "attendance",
    section: "Nhân sự",
    title: "Chấm công - Bảng lương",
    menuName: "attendance",
    features: [
      {
        path: "/attendance",
        title: "Chấm công - Bảng lương (Menu)",
        actions: ["VIEW", "UPDATE", "LOCK", "UNLOCK", "VIEW_SENSITIVE", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "department",
    section: "Nhân sự",
    title: "Phòng ban",
    menuName: "department",
    features: [
      {
        path: "/department",
        title: "Danh sách phòng ban (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE"],
      },
    ],
  },
  {
    key: "log",
    section: "Quản trị",
    title: "Quản lý log",
    menuName: "log",
    features: [
      {
        path: "/log",
        title: "Danh sách log (Menu)",
        actions: ["VIEW"],
      },
    ],
  },
  {
    key: "configuration",
    section: "Quản trị",
    title: "Quản lý cấu hình",
    menuName: "configuration",
    features: [
      {
        path: "/configuration",
        title: "Danh sách cấu hình (Menu)",
        actions: ["VIEW", "UPDATE"],
      },
    ],
  },
];

export const permissionKey = (path: string, action: string) => `${path}|${action}`;

// Toàn bộ (path, action) khai báo trong cấu hình
export const allPermissionItems = () =>
  permissionMenu.flatMap((group) =>
    group.features.flatMap((feature) =>
      feature.actions.map((action) => ({
        path: feature.path,
        action,
        title: feature.title,
      })),
    ),
  );
